import type {
  DonutChartCell,
  DonutChartProps as MantineDonutChartProps,
} from '@mantine/charts'

import { TYPE_GROUP } from '@/components/@Shared/DonutChart/DonutChart.config'

export type DonutChartCellData = DonutChartCell & {
  /** Secondary tooltip line, eg. spent amount with its share of the total */
  description?: string
  /** Readable name shown in the tooltip, falls back to `name` */
  label?: string
}

export type DonutChartProps = Omit<MantineDonutChartProps, 'data'> & {
  data: DonutChartCellData[]
  bigger?: boolean
  extended?: boolean
}

export function isTypeGroupKey(name: string): name is keyof typeof TYPE_GROUP {
  return name in TYPE_GROUP
}
